import React, { ReactElement } from "react";
import ReactModal from "react-modal";

ReactModal.setAppElement(`#___gatsby`);

const modalStyles = {
  overlay: {
    backgroundColor: "rgba(0, 0, 0, 0.58)",
    zIndex: 9999
  },
  content: {
    position: "relative",
    top: "auto",
    left: "auto",
    right: "auto",
    bottom: "auto",
    maxWidth: "960px",
    margin: "32px auto",
    padding: 0,
    border: 0,
    zIndex: 9999
  }

};

type Props = {
  open: boolean,
  setOpen: (open: boolean) => void,
  children: ReactElement
}

export const Modal = ({ open, setOpen, children }: Props) => {
  const closeModal = () => setOpen(false);

  return <ReactModal isOpen={open} onRequestClose={closeModal} style={modalStyles} shouldCloseOnOverlayClick={false}
                     preventScroll>
    {children}
  </ReactModal>;
};
